module.exports = "<settings-screen>\n  <div class=\"row m-t-5\">\n    <div class=\"col-md-4\">\n      <p>\n        <a href=\"destinations/new\" class=\"btn btn-default\"><i class=\"fa fa-plus\"></i> New Alert Destination</a>\n      </p>\n      <div class=\"list-group\">\n        <a ng-href=\"destinations/{{destination.id}}\" class=\"list-group-item\" ng-repeat=\"destination in destinations\"><i class=\"fa {{destination.icon}}\"></i> {{destination.name}}</a>\n      </div>\n    </div>\n  </div>\n</settings-screen>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/pages/destinations/list.html
// module id = 772
// module chunks = 1